/**
 * Bilingual copy for the Blog listing page.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  title: 'AKAS Blogs | Business Cloud Solutions',
  description:
    'Insights on AKAS cloud ERP — HR, CRM, sales, revenues, purchases, expenses, and accounting.',
  heading: 'Blog',
  searchPlaceholder: 'Search',
  loading: 'Loading blog posts...',
  noResults: 'No blog posts found',
  noResultsHint: 'Try a different search term or check back later for new content.',
};

export type Copy = typeof en;

export const km: Copy = {
  title: 'ប្លុក AKAS | ដំណោះស្រាយលើពពកសម្រាប់អាជីវកម្ម',
  description:
    'អត្ថបទអំពីប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម AKAS — ធនធានមនុស្ស អតិថិជន ការលក់ ចំណូល ការទិញ ចំណាយ និងគណនេយ្យ។',
  heading: 'ប្លុក',
  searchPlaceholder: 'ស្វែងរក',
  loading: 'កំពុងផ្ទុកអត្ថបទ...',
  noResults: 'រកមិនឃើញអត្ថបទទេ',
  noResultsHint: 'សូមសាកល្បងពាក្យស្វែងរកផ្សេង ឬត្រឡប់មកមើលវិញនៅពេលក្រោយ សម្រាប់អត្ថបទថ្មី។',
};
